<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div
    id="defaultId1 "
    class="margin-top10 margin-bottom10"
    v-loading="RiskLoding"
  >
    <div id="g2ede8" class="operations-content">
      <h2 id="gf7b16" class="operations-head-content">
        <div>
          <span class="operations-headspan">
            {{ $t("TradeByCountry.DistributionofImportExportCountries") }}
          </span>
          <el-select
            class="map_select"
            v-model="Importyear"
            :placeholder="$t('TradeByCountry.PleaseSelect')"
            @change="getData"
          >
            <el-option
              v-for="item in Yearoptions"
              :key="item.year"
              :disabled="!item.hasData"
              :label="item.year"
              :value="item.year"
            >
            </el-option>
          </el-select>
        </div>

        <div class="perations-content-left">
          <span
            :class="
              activeIEports == '1'
                ? 'perations-button perations-button-active'
                : 'perations-button'
            "
            @click="ceckIEports('1')"
            >{{ $t("SearchTrade.Imports") }}</span
          >
          <span
            @click="ceckIEports('2')"
            :class="
              activeIEports == '2'
                ? 'perations-button perations-button-active'
                : 'perations-button'
            "
            >{{ $t("SearchTrade.Exports") }}</span
          >
        </div>
      </h2>

      <div class="operations-box">
        <div class="graph_controls">
          <button @click="fullScreen" v-if="!isFullScreen" class="btn_control">
            <i class="iconfont icon-quanping" />
          </button>
          <button @click="exitFullScreen" v-else class="btn_control">
            <i class="iconfont icon-suohui" />
          </button>
          <button @click="zoomLarge" class="btn_control">
            <i class="iconfont icon-fangda" />
          </button>
          <button @click="zoomSmall" class="btn_control">
            <i class="iconfont icon-suoxiao" />
          </button>
          <button @click="resetZoom" class="btn_control">
            <i class="iconfont icon-huanyuan" />
          </button>
        </div>

        <div
          ref="SupplyChainEchart"
          style="width: 100%; height: 642px"
          :class="isFullScreen ? 'fullscream_trade_map_chart' : ''"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNum } from "@/views/company/details/Background/utils";

import {
  tradeTrends,
  geCountryDistributionYears,
  geCountryDistribution,
} from "@/api/companyApi.js";
export default {
  name: "",
  // props: {},
  components: {},
  data() {
    return {
      // myChart: null,   echartsBox
      isFullScreen: false,
      scaleLevel: "80%",
      scaleper: 80,

      data: {
        links: [],
        nodes: [],
      },

      Importyear: "",
      Yearoptions: [],

      activeIEports: "1",
      importTrendListEcharts: [],
      allData: null,
      sourceData: [],
      diskData: [],

      reLoginVis: false,
      RiskLoding: false,
    };
  },
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: false,
    });
    this.getselectHasDataYearsWithImportOrExport();
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    // 缩放
    zoomLarge() {
      this.scaleper = this.scaleper + 20 < 200 ? this.scaleper + 20 : 200;
      this.scaleLevel = this.scaleper + "%";
      this.resizeFn();
    },
    zoomSmall() {
      this.scaleper = this.scaleper - 20 > 20 ? this.scaleper - 20 : 20;
      this.scaleLevel = this.scaleper + "%";
      this.resizeFn();
    },
    resetZoom() {
      this.scaleper = 80;
      this.scaleLevel = "80%";
      this.resizeFn();
    },
    // 全屏
    fullScreen() {
      const elem = document.getElementsByClassName("operations-box")[0];

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      this.isFullScreen = true;
      this.resizeFn();
    },
    // 退出全屏
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.isFullScreen = false;
      this.resizeFn();
    },

    resizeFn() {
      this.suppleEchart();
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getData();
    },
    getselectHasDataYearsWithImportOrExport() {
      geCountryDistributionYears({
        type: this.activeIEports,
        countryCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.Yearoptions = res.data;
          this.Importyear = res.data[0].year;
          this.getData();
        } else {
          this.Yearoptions = [];
        }
      });
    },
    getData() {
      this.RiskLoding = true;
      geCountryDistribution({
        type: this.activeIEports,
        countryCode: this.$route.query.id3a,
        impYear: this.Importyear,
      }).then((res) => {
        if (res.code == 200) {
          this.diskData = res.data;
          this.suppleEchart();
          this.RiskLoding = false;
        } else {
          this.RiskLoding = false;
        }
      });
    },
    suppleEchart() {
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      let that = this;
      const formatUtil = this.$echarts.format;
      const option = {
        tooltip: {
          formatter: function (info) {
            var value = info.data.valueDesc;
            var treePathInfo = info.treePathInfo;
            var treePath = [];
            for (var i = 1; i < treePathInfo.length; i++) {
              treePath.push(treePathInfo[i].name);
            }
            return [
              '<div class="tooltip-title">' +
                formatUtil.encodeHTML(treePath.join("/")) +
                "</div>",
              that.$t("TradeByCountry.transactionvolume") +
                ": " +
                formatUtil.addCommas(  formatNum (value)), 
            ].join("");
          },
        },
        series: [
          {
            name: this.$t("TradeByCountry.transactionvolume"),
            type: "treemap",
            visibleMin: 0,
            // zoom: this.scaleLevel, // 初始缩放级别
            width: this.scaleLevel,
            height: this.scaleLevel,
            roam: "move", // 禁止拖动缩放
            label: {
              show: true,
              formatter: "{b}",
            },
            //去除底部路径
            breadcrumb: {
              show: false,
            },
            itemStyle: {
              borderColor: "#fff",
            },
            levels: that.getLevelOption(),
            data: that.diskData,
          },
        ],
      };

      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },
    getLevelOption() {
      return [
        {
          itemStyle: {
            borderWidth: 0,
            gapWidth: 5,
          },
        },
        {
          itemStyle: {
            gapWidth: 1,
          },
        },
        {
          colorSaturation: [0.35, 0.5],
          itemStyle: {
            gapWidth: 1,
            borderColorSaturation: 0.6,
          },
        },
      ];
    },
    
  },
  computed: {},
};
</script>
<style scoped>
.operations-head {
  display: flex;
  justify-content: space-between;
}

.operations-headspan {
  margin-right: 26px;
  color: #009ea7;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.table-content-color {
  color: #009ea7;
}

.perations-button-active {
  background: #ffffff !important;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.2);
  border-radius: 1.5rem;
  color: #009ea7 !important;
  cursor: pointer;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}
.map_select {
  width: 200px;
}
.font26 {
  font-size: 26px !important;
}
.operations-box {
  position: relative;
}

.fullscream_trade_map_chart {
  height: 100vh !important;
}
.graph_controls {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 8;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 40px;
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.btn_control {
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn_control i {
  font-size: 20px;
}
.btn_control:hover {
  background-color: #f0f0f0;
  border-color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_control:active {
  background-color: #e0e0e0;
}

@media screen and (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .map_select {
    width: 150px;
  }
  .operations-headspan {
    margin-right: 20px;
  }
  .font26 {
    font-size: 20px !important;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .map_select {
    width: 130px;
    margin-left: 20px;
  }
  .operations-headspan {
    margin-right: 18px;
  }
  .font26 {
    font-size: 18px !important;
  }
}
</style>
